'use es6';

import { SHOW_LAYOUT_SECTION_EDITOR_OPTIONS, LAYOUT_EDITOR_VIRTUAL_BODY_FIELD, MODULE_ID_MIGRATION, JS_RAW_ASSET_CREATION, HUBL_V3_GATE, SERVERLESS_PACKAGES, PROJECTS, MODULE_STYLE_FIELDS, DFS_PROJECTS, EMAIL_BUSINESS_UNIT_GATE, USE_CONTENT_TYPES, CUSTOM_THEME_CHILD_CREATION, MODULE_CATEGORIES, DND_AREAS_IN_CUSTOM_TEMPLATES } from 'DesignData/enums/Gates';
import { isUngated } from 'DesignData/selectors/auth';
export const getShowLayoutSectionEditorOptions = state => isUngated(state, {
  gate: SHOW_LAYOUT_SECTION_EDITOR_OPTIONS
});
export const getIsVirtualBodyUngated = state => !!isUngated(state, {
  gate: LAYOUT_EDITOR_VIRTUAL_BODY_FIELD
});
export const getIsModuleIdMigrationUngated = state => isUngated(state, {
  gate: MODULE_ID_MIGRATION
});
export const getIsJSRawAssetCreationUngated = state => isUngated(state, {
  gate: JS_RAW_ASSET_CREATION
});
export const getIsUngatedForFullHublSupport = state => isUngated(state, {
  gate: HUBL_V3_GATE
});
export const getIsServerlessDeploymentUngated = state => isUngated(state, {
  gate: SERVERLESS_PACKAGES
});
export const getIsProjectsUngated = state => isUngated(state, {
  gate: PROJECTS
});
export const getIsModuleStyleFieldsUngated = state => isUngated(state, {
  gate: MODULE_STYLE_FIELDS
});
export const getIsDFSProjectsUngated = state => isUngated(state, {
  gate: DFS_PROJECTS
});
export const getIsUngatedForBusinessUnit = state => isUngated(state, {
  gate: EMAIL_BUSINESS_UNIT_GATE
});
export const getIsUngatedForContentTypes = state => isUngated(state, {
  gate: USE_CONTENT_TYPES
});
export const getIsUngatedForCustomThemeChildCreation = state => isUngated(state, {
  gate: CUSTOM_THEME_CHILD_CREATION
});
export const getIsModuleCategoriesUngated = state => isUngated(state, {
  gate: MODULE_CATEGORIES
});
export const getIsUngatedForDndAreasInCustomEmailTemplates = state => isUngated(state, {
  gate: DND_AREAS_IN_CUSTOM_TEMPLATES
});